import React, { Component } from "react";
import cookie from "react-cookies";
import { connect } from "react-redux";
import { Table, Icon, Button, Row, Modal, message, Col, Pagination, Divider } from 'antd';
import { startUpload, slideUpdateAlert, startTiling } from '../../action/slides.action'
import { changePage } from '../../action/search.action';
import { deleteSlide } from "../../action/slides.action";
import { historyMP } from "../../helper/history";
import FilterComp from "../dashboard/filter";
import SearchBar from "../dashboard/searchbar";
import { globalUrlPrefix } from '../../utils/const'
import { getTilingComponent, getNameComponent, getTagsComponent, getPreviewComponent, getLabelComponent, getDeleteComponent, getStarredComponent, getDbEntryComponent, getUploadComponent, getMorphleIDComponent } from "./slidelist_utils";

const ButtonGroup = Button.Group;

const bareColoumns = [
    {
        dataIndex: 'name',
        key: 'name',
        width: 10,
    },
    {
        dataIndex: 'previewComponent',
        key: 'preview',
        width: 100,
    },
    {
        dataIndex: 'labelComponent',
        key: 'label',
        width: 100,
    }
]

const columns = [
    {
        dataIndex: 'starredComponent',
        key: 'starred',
        width: 10,
    },
    {
        dataIndex: 'uploadComponent',
        key: 'upload',
        width: 10,
    },
    ...bareColoumns
    , 
    {
        dataIndex: 'tagsComponent',
        key: 'tags',
        width: 5
    }, 
    {
        dataIndex: 'date',
        key: 'date',
        width: 20,
    },
    {
        dataIndex: 'tilingComponent',
        key: 'tiling',
        width: 10,
    }
];

let deleteColoumn = {
    dataIndex: 'deleteComponent',
    key: 'delete',
    width: 10,
}

const insert = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index)
]

const adminColumns = [
    {
        dataIndex: 'morphleIDComponent',
        key: 'morphleID',
        width: 5,
    }
]

const staffColumns = [
    {
        dataIndex: 'scanTimeComponent',
        key: 'scanTime',
        width: 5,
    },
    {
        dataIndex: 'scanSpeedComponent',
        key: 'scanSpeed',
        width: 5,
    }, 
    {
        dataIndex: 'dbEntryComponent',
        key: 'dbEntry',
        width: 5,
    }
]

const pageSize = 12;

export class SlideList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRowKeys: []
        }

        this.is_cloud = cookie.loadAll().deployment_mode === 'cloud';
        this.isMobile = cookie.loadAll().isMobile == 'true';
        this.iOS = cookie.loadAll().iOS === "true";
    }
    
    linkViewer = (id) => {
        window.location.href = "/" + globalUrlPrefix + "/viewer/" + id;
    };
    
    handleUpload = (morphle_id, id, allIds, uploadDebug, uploadDebugOnly) => {
        this.props.dispatch(startUpload(morphle_id, id, allIds, uploadDebug, uploadDebugOnly));
    }

    handleDelete = (slide) => {
        this.props.dispatch(deleteSlide(slide, this.props.urlState))
    }

    starSelectedRows = () => {
        this.state.selectedRowKeys.map((value, index) => {
            this.handleStarButton(this.props.allSlides[value], true);
        });
    }

    uploadSelectedRows = () => {
        this.state.selectedRowKeys.map((value, index) => {
            let slide = this.props.allSlides[value];
            this.props.dispatch(startUpload(slide.morphle_id, slide.id, this.props.allIds, false, false));
        });
    }

    tileSelectedRows = () => {
        this.state.selectedRowKeys.map((value, index) => {
            this.props.dispatch(startTiling(this.props.allSlides[value].morphle_id, this.props.allIds));
        });
    }

    unstarSelectedRows = () => {
        this.state.selectedRowKeys.map((value, index) => {
            this.handleStarButton(this.props.allSlides[value], false);
        });
    }

    deleteSelectedRows = (e) => {
        this.state.selectedRowKeys.map((value, index) => {
            if (this.props.allSlides[value] == undefined) return;
            this.handleDelete(this.props.allSlides[value]);
        });
        message.loading("Scheduling slides for Deletion");
    }

    handleStarButton = (slide, input) => {
        let val = {
            morphle_id: slide.morphle_id,
            path: slide.path,
            date: slide.date,
            specimen_type: slide.specimen_type,
            name: slide.name,
            starred: input, 
            displayOrder: slide.displayOrder
        };
        this.props.dispatch(slideUpdateAlert(slide.id, val));
    };

    handleNameChange = (slide, newName) => {
        let val = {
            morphle_id: slide.morphle_id,
            path: slide.path,
            date: slide.date,
            specimen_type: slide.specimen_type,
            name: newName,
            starred: slide.starred, 
            displayOrder: slide.displayOrder
        };
        this.props.dispatch(slideUpdateAlert(slide.id, val));
    };

    openDeleteModal = () => {

        var deletedIDs = "";

        this.state.selectedRowKeys.map((value, index) => {
            if (this.props.allSlides[value] == undefined) return;
            if (index != this.state.selectedRowKeys.length - 1) deletedIDs += (this.props.allSlides[value] || {}).name + ", ";
        });

        deletedIDs += this.props.allSlides[this.state.selectedRowKeys[this.state.selectedRowKeys.length - 1]].name;

        const deleteRowsHandle = this.deleteSelectedRows;

        Modal.confirm({
            title: 'Following scans will be deleted. Confirm?',
            icon: <Icon type="info-circle"></Icon>,
            content: (<Row>{deletedIDs}</Row>),
            onOk() { deleteRowsHandle() },
            onCancel() { }
        });
    }

    getRowActionsIfAtleastOneRowSelected = () => {
        return this.state.selectedRowKeys.length > 0 ?
            <ButtonGroup key={1}>
                <Button onClick={() => { this.setState({ selectedRowKeys: Object.keys(this.props.allSlides).map((value) => parseInt(value)) }) }}>
                    Select All Scans
                    </Button>
                <Button key={0} onClick={() => { this.setState({ selectedRowKeys: [] }) }}>
                    Cancel Selection
                    </Button>
                {cookie.loadAll().superuser === "true" ?
                    <Button key={1} onClick={this.tileSelectedRows}>
                        Start Tiling
                    </Button> : undefined}
                {cookie.loadAll().deployment_mode === 'offline' ? 
                    <Button key={-1} onClick={this.uploadSelectedRows}>
                        Upload
                        <Icon style={{ fontSize: "13px" }} type="cloud-upload" />
                    </Button> : undefined }
                <Button key={2} onClick={this.starSelectedRows}>
                    Star
                        <Icon
                        type="star"
                        theme="filled"
                        style={{ color: "#f5667b", fontSize: "13px" }}
                    />
                </Button>
                <Button key={3} onClick={this.unstarSelectedRows}>
                    Unstar
                        <Icon
                        type="star"
                        theme="filled"
                        style={{ fontSize: "13px" }}
                    />
                </Button>
                {cookie.loadAll().is_staff === "true" ?
                <Button key={4} onClick={this.openDeleteModal}>
                    Delete
                            <Icon
                        type="delete"
                        theme="filled"
                        style={{ fontSize: "13px" }}
                    /> 
                </Button> : undefined }
            </ButtonGroup> :
            <Button onClick={() => { this.setState({ selectedRowKeys: Object.keys(this.props.allSlides).map((value) => parseInt(value)) }) }}>
                Select All Scans
                </Button>
    }

    getFilters = () => {
        return this.state.selectedRowKeys.length > 0 ? undefined : <FilterComp />;
    }

    getRowActions = () => {
        return <Row>
            <Col span={this.state.selectedRowKeys.length > 0 ? 24 : 4}>
                <span key={0} style={{ marginRight: "10px" }}>
                    {this.state.selectedRowKeys.length > 0 ? "What do you want to do with the selected scans ? " : ""}
                </span>
                {this.getRowActionsIfAtleastOneRowSelected()}
            </Col>
            <Col span={this.state.selectedRowKeys.length > 0 ? 0 : 20}>{this.getFilters()}</Col>
        </Row>
    }

    getPaginationDiv = () => {
        return <Pagination
            total={this.props.numPages * pageSize}
            showTotal={(total, range) =>
                this.isMobile ? `` : `Showing ${range[0]}-${range[1]} out of ${total} total scans`
            }
            current={this.props.urlState.page}
            pageSize={pageSize}
            defaultCurrent={1}
            onChange={this.updatePage}
            size="small"
            className="pagination-mp"
        />
    }

    updatePage = (pageNumber) => {
        historyMP.push('/' + globalUrlPrefix + '/dashboard?page=' + pageNumber);
        this.props.dispatch(changePage(pageNumber, this.props.urlState));
    }

    getTableSource = (allSlides) => {
        let allSlidesList = []
        Object.keys(allSlides).sort(
            function (a, b) {
                return allSlides[a].displayOrder - allSlides[b].displayOrder;
            }
        ).map((key) => {
            let slide = allSlides[key];
            if (!slide.isDeleted) {
                allSlidesList.push({
                    id: slide.id,
                    name: getNameComponent(slide, this.handleNameChange),
                    tagsComponent: getTagsComponent(slide, this.props.dispatch, this.props.urlState),
                    previewComponent: getPreviewComponent(slide, this.is_cloud, this.isMobile),
                    labelComponent: getLabelComponent(slide, this.is_cloud, this.isMobile),
                    starredComponent: getStarredComponent(slide, this.handleStarButton),
                    uploadComponent: getUploadComponent(slide, this.props.allIds, this.handleUpload),
                    deleteComponent: getDeleteComponent(slide, this.handleDelete),
                    tilingComponent: getTilingComponent(slide, this.props.allIds, this.props.dispatch),
                    dbEntryComponent: getDbEntryComponent(slide),
                    morphleIDComponent: getMorphleIDComponent(slide),
                    scanTimeComponent: <div>{slide.scan_time}</div>, 
                    scanSpeedComponent: <div>{slide.scan_speed}</div>, 
                    date: <div>{slide.date}</div>
                })
            }
        });

        return allSlidesList;
    }

    render() {

        let tableSource = this.getTableSource(this.props.allSlides);

        let finalColumns = columns;

        if (this.isMobile) {
            finalColumns = bareColoumns;
        }

        if (cookie.loadAll().is_staff === "true") {
            for (var i = 0; i < staffColumns.length; i++) {
                finalColumns = insert(finalColumns, finalColumns.length - 1, staffColumns[i]);
            }
            finalColumns = insert(finalColumns, finalColumns.length, deleteColoumn);
        }

        if (cookie.loadAll().superuser === "true") {
            for (var i = 0; i < adminColumns.length; i++) {
                finalColumns = insert(finalColumns, finalColumns.length - 1, adminColumns[i]);
            }
        }

        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys: selectedRowKeys
                })
            },
            selectedRowKeys: this.state.selectedRowKeys
        };

        const onRow = (record, rowIndex) => {
            return {
                onClick: event => {
                    this.linkViewer(record.id);
                },
            };
        }

        let rowActions = this.isMobile ? undefined : 
                            [
                                <Divider key={3}/>, 
                                <Row key={0} className="row-actions">
                                    {this.getRowActions()}
                                </Row>
                            ];

        return (
            [<Row key={0} className="fixed-controls-dashboard" id="fixed-controls-dashboard">
                <Col span={24}>
                    <Row key={-2} style={{ marginTop: 30 }}>
                        <Col span={this.isMobile ? 22 : 12} offset={this.isMobile ? 1 : 6}>
                            <SearchBar />
                        </Col>
                    </Row>
                    <Row key={-1}>
                        {this.getPaginationDiv()}
                    </Row>
                    {rowActions}
                    <Divider />
                </Col>
            </Row>,
            <Row key={1} className="scrollable-dashboard">
                <Table
                    key={1}
                    loading={this.props.isFetching}
                    dataSource={tableSource}
                    columns={finalColumns}
                    rowKey="id"
                    pagination={false}
                    showHeader={false}
                    rowSelection={this.isMobile ? undefined : rowSelection}
                    onRow={onRow}
                    rowClassName="slide-table-rows"
                />
                <Row key={2}>
                    {this.getPaginationDiv()}
                </Row>
            </Row>
            ]
        )
    }
}

const mapStateToProps = (state) => {

    return {
        allSlides: state.slidesReducer,
        allIds: Object.keys(state.slidesReducer),
        isFetching: state.searchReducer.isFetching,
        numPages: state.dashboardReducer.numPages,
        urlState: state.searchReducer
    }
}

export default connect(mapStateToProps)(SlideList);
